import { CategoriesMainContainer } from '@/modules/Categories/containers';

const Categories = (): JSX.Element => <CategoriesMainContainer />;

export default Categories;
